import {BASE_API_URL} from "./config";
import {createAxios} from "./axios";

const formSelectionAptCodeApi = createAxios({
    baseURL: BASE_API_URL + '/form-selection/appointment-code'
});

export const fetchAllAvailableCodes = () => {
    return formSelectionAptCodeApi.get();
}